import { UserInterface } from 'app/interfaces/user.interface';
export class UserLogged {
    accessToken: string;
    user: UserInterface;
  }
